import ChartList from '@/features/(charts)/chart-list/ui/chart-list';

const ChartListPage = () => {
  return <ChartList />;
};

export default ChartListPage;
